import { render, staticRenderFns } from "./Tipouso.vue?vue&type=template&id=5b92c43e&scoped=true&"
import script from "./Tipouso.vue?vue&type=script&lang=js&"
export * from "./Tipouso.vue?vue&type=script&lang=js&"
import style0 from "./Tipouso.vue?vue&type=style&index=0&id=5b92c43e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b92c43e",
  null
  
)

export default component.exports